<div class="form-group" [ngClass]="{ 'has-error': control.invalid, required: required }">
  <label *ngIf="label" [attr.for]="id">{{ label }}</label>
  <div [ngClass]="{ 'input-group': currencySign, 'hide-arrows': hideArrows }">
    <span class="input-group-addon" *ngIf="currencySign">{{ currencySign }}</span>
    <input
      #inputCurrency
      class="{{ class }}"
      [attr.id]="id"
      [attr.data-integration-id]="'input-currency'"
      [attr.name]="name"
      [attr.type]="getInputType()"
      [attr.step]="step"
      [attr.placeholder]="placeholder"
      [formControl]="userControl"
      [required]="required"
      [attr.disabled]="disabled ? 'true' : null"
      (input)="onNumberChanged($event)"
      (wheel)="handleScroll($event)"
      (focusout)="onFocusOut()"
      [attr.customScanning]="true"
    />
  </div>
</div>
